import { memo, Suspense, lazy } from 'react';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';

const Interface = lazy(() => import('@/components/dashboard/Interface').then(module => ({ default: module.Interface })));

interface DefaultRouterProps {
  currentRole: string;
}

export const DefaultRouter = memo<DefaultRouterProps>(({ currentRole }) => {
  return (
    <Suspense fallback={
      <div className="flex items-center justify-center min-h-[400px]">
        <LoadingSpinner 
          message="Loading interface..." 
          size="lg" 
          fullScreen={false} 
        />
      </div>
    }>
      <Interface currentRole={currentRole} />
    </Suspense>
  );
});

DefaultRouter.displayName = 'DefaultRouter';